export default __webpack_public_path__ + "static/heroBg-e33604e477d541e315a8bb738f335006.png";